<script setup lang="ts">
import { type InflowSource, useMatching } from './useMatching';

definePageMeta({
  middleware: 'activation-check',
});
useAppMeta({
  title: 'マッチング中',
  noindex: true,
});

const route = useRoute();
const router = useRouter();
const alert = useAlert();

const plannerId = getIntQuery(route.params.id);
if (plannerId == null) {
  throw createError({
    statusCode: 404,
    statusMessage: 'このページは存在しません',
  });
}
const inflowSource = computed<InflowSource>(() =>
  getStringQuery(route.query.inflow_source)?.trim() === 'qr' ? 'qr' : 'normal'
);

const isOnlyCreateRoom = computed(() => 'only_create_room' in route.query);
const persistedMessageUuid = getStringQuery(route.query.persisted_message_uuid);

const { mutate } = useMatching({
  plannerId,
  inflowSource: inflowSource.value,
  isOnlyCreateRoom: isOnlyCreateRoom.value,
});
onBeforeMount(async () => {
  const result = await mutate();
  if (result.ok) {
    return router.replace({
      path: `/chat/${result.roomId}`,
      query: {
        ...(persistedMessageUuid
          ? { persisted_message_uuid: persistedMessageUuid }
          : {}),
      },
    });
  }
  alert.error(
    'チャットの表示に失敗しました。恐れ入りますが、時間を置いて再度お試しください。'
  );
});
</script>

<template>
  <div />
</template>
